import React from "react";
import { cn } from "@/lib/utils";
import { TrendingUp, TrendingDown, Loader2 } from "lucide-react";

export const VegDot = ({ veg, className }) => (
  <span className={cn("inline-flex h-4 w-4 items-center justify-center border-2 rounded-[3px]",
    veg ? "border-emerald-600" : "border-red-600", className)} title={veg ? "Veg" : "Non-veg"}>
    <span className={cn("h-2 w-2 rounded-full", veg ? "bg-emerald-600" : "bg-red-600")} />
  </span>
);

export const KpiCard = ({ label, value, icon: Icon, delta, sub, accent = "orange", testid }) => {
  const accents = {
    orange: "bg-orange-50 text-orange-600", emerald: "bg-emerald-50 text-emerald-600",
    sky: "bg-sky-50 text-sky-600", violet: "bg-violet-50 text-violet-600",
    amber: "bg-amber-50 text-amber-600",
  };
  return (
    <div className="rounded-2xl bg-card border border-border p-5 shadow-[0_2px_8px_rgba(28,25,23,0.04)] hover:shadow-[0_8px_24px_rgba(28,25,23,0.08)] transition-shadow" data-testid={testid}>
      <div className="flex items-start justify-between">
        <p className="text-xs font-bold uppercase tracking-widest text-muted-foreground">{label}</p>
        {Icon && <div className={cn("h-9 w-9 rounded-xl grid place-items-center", accents[accent])}><Icon size={18} /></div>}
      </div>
      <div className="mt-3 font-display text-2xl sm:text-3xl font-bold tracking-tight text-foreground">{value}</div>
      <div className="mt-1 flex flex-wrap items-center gap-x-2 gap-y-1 text-sm">  
        {typeof delta === "number" && (
          <span className={cn("inline-flex items-center gap-0.5 font-semibold", delta >= 0 ? "text-emerald-600" : "text-red-600")}>
            {delta >= 0 ? <TrendingUp size={14} /> : <TrendingDown size={14} />}{Math.abs(delta)}%
          </span>
        )}
        {sub && <span className="text-muted-foreground">{sub}</span>}
      </div>
    </div>
  );
};

export const SectionTitle = ({ title, subtitle, right }) => (
  <div className="flex items-end justify-between gap-4 mb-4">
    <div>
      <h2 className="font-display text-xl font-semibold tracking-tight text-foreground">{title}</h2>
      {subtitle && <p className="text-sm text-muted-foreground mt-0.5">{subtitle}</p>}
    </div>
    {right}
  </div>
);

export const PageHeader = ({ title, subtitle, actions }) => (
  <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 mb-6">
    <div>
      <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight text-foreground">{title}</h1>
      {subtitle && <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>}
    </div>
    {actions && <div className="flex items-center gap-2">{actions}</div>}
  </div>
);

export const Loader = ({ label = "Loading" }) => (
  <div className="flex items-center justify-center py-24 text-muted-foreground gap-2">
    <Loader2 className="animate-spin" size={18} /> {label}…
  </div>
);

export const EmptyState = ({ icon: Icon, title, subtitle }) => (
  <div className="flex flex-col items-center justify-center py-20 text-center">
    {Icon && <div className="h-14 w-14 rounded-2xl bg-muted grid place-items-center mb-4 text-muted-foreground"><Icon size={26} /></div>}
    <p className="font-display text-lg font-semibold text-foreground">{title}</p>
    {subtitle && <p className="text-sm text-muted-foreground mt-1 max-w-sm">{subtitle}</p>}
  </div>
);
